import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);
export function formatMessageTime(date) {
    return dayjs(date).format('HH:mm A');
}
export function formatMessageGroupDate(date) {
    return dayjs(date).format('dddd, MMM Do, YYYY');
}
